module.exports = __webpack_public_path__ + "static/media/comparision_bg.343f7c3c.jpg";